var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPhone = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20246_3417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8213 3.8982L19.6647 0.744615C19.2794 0.359309 18.7637 0.142944 18.2184 0.142944C17.673 0.142944 17.1573 0.356345 16.772 0.744615L13.3724 4.13827C12.9871 4.52358 12.7707 5.04226 12.7707 5.58762C12.7707 6.13594 12.9841 6.64869 13.3724 7.03696L16.028 9.69557C15.4231 11.1052 14.5538 12.3859 13.4672 13.4686C12.3795 14.5623 11.108 15.4248 9.69716 16.0353L7.04151 13.3767C6.65621 12.9914 6.14049 12.7751 5.59513 12.7751C5.32614 12.7741 5.05965 12.8268 4.81129 12.9301C4.56292 13.0334 4.33768 13.1852 4.14875 13.3767L0.746202 16.7704C0.360896 17.1557 0.144531 17.6744 0.144531 18.2197C0.144531 18.7681 0.357932 19.2808 0.746202 19.6691L3.89978 22.8227C4.55777 23.4806 5.46472 23.8571 6.39538 23.8571C6.58804 23.8571 6.77476 23.8422 6.96445 23.8096C10.8886 23.1635 14.7832 21.074 17.9279 17.9322C21.0696 14.7846 23.1562 10.89 23.8083 6.96286C23.995 5.84844 23.6215 4.70141 22.8213 3.8982ZM21.7069 6.61016C21.1289 10.1046 19.2498 13.5901 16.4193 16.4206C13.5888 19.2512 10.1062 21.1303 6.61175 21.7082C6.17309 21.7823 5.72258 21.6341 5.40248 21.317L2.30521 18.2197L5.5892 14.9328L9.13995 18.4894L9.16662 18.5161L9.80682 18.279C11.748 17.5653 13.5107 16.4381 14.9729 14.9754C16.435 13.5127 17.5617 11.7496 18.2747 9.8082L18.5118 9.168L14.9314 5.59058L18.2154 2.30362L21.3127 5.40089C21.6328 5.72099 21.781 6.1715 21.7069 6.61016Z",
    fill: "#2A2A2A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20246_3417"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPhone, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/phone.346ade9a.svg";
export { ForwardRef as ReactComponent };